module.exports = __webpack_public_path__ + "static/media/CTLI_14-235w.dbb4eb03.webp";